import { render, staticRenderFns } from "./messagesList.vue?vue&type=template&id=80a2cc7c&scoped=true"
import script from "./messagesList.vue?vue&type=script&lang=js"
export * from "./messagesList.vue?vue&type=script&lang=js"
import style0 from "./messagesList.vue?vue&type=style&index=0&id=80a2cc7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a2cc7c",
  null
  
)

export default component.exports